import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import { startSxpProxy } from '../../utils/api'
import { ADMIN_PROJECT_ID } from '../../utils/constants'
import KeycloakService from '../../utils/keycloakService'
import Asterisk from '../../components/Asterisk'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'
import {
  forms,
  formValues,
  intent,
  OrganizationIntent,
} from '../administration/constants'
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  List,
  MenuItem,
  Paper,
  styled,
  TextField,
  useTheme,
} from '@mui/material'
import {
  fieldRequriedError,
  phoneRegExp,
  phoneFieldError,
  emailFieldError,
  reqPriceList,
} from '../ipRegistration/Constants'
import { partnerForm } from '../Radiology/Constants/constants'
import { radiologyEndPoint } from '../Radiology/RadiologyEndPoints'
import { radiologyColor } from '../Radiology/Utils/RadiologyColors'
import { activeOptions } from './constants'
import { getAllPriceList } from '../../services/AdminService'
import { useAppSelector } from '../../app/hooks'
import { selectLocations } from '../location/locationSlice'
type PriceListItem = {
  id: string
  name: string
}
type PartnerProps = {
  type: string
  name: string
  phoneNumber: string
  email: string
  status: string
  fhirId: string
  location: string
  address: string
  govId: string
  department: string
  designation: string
  isLab: boolean
  isRadiology: boolean
  isVendorRelate: boolean
  isCustomerRelate: boolean
  odoo_partner_id: string
  pricelist: { id: string; name: string }
  street_no: string
  street: string
  city: string
  state: string
  pin: number
  gst: string
  pan: string
}
const styles = () => ({
  partnerRegisterFormContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '0.5% 23% 3% 1%',
    overflowY: 'auto',
    '& .MuiInputBase-input': {
      fontSize: '12px !important',
      minWidth: '230px',
      background: 'white',
    },
    '& .MuiInputLabel-root': {
      fontSize: '12px !important',
    },
    '& .MuiSelect-select': {
      padding: '6px 8px',
    },
    '& .MuiFormControlLabel-label': {
      fontSize: '12px !important',
      fontWeight: 500,
    },
    '& .css-1hpqosy-MuiFormControlLabel-root': {
      marginLeft: '5px !important',
      marginRight: '5px !important',
    },
  },
  partnerRegisterFormRow: {
    display: 'flex',
    justifyContent: 'start',
    marginBottom: '1rem',
    flexWrap: 'wrap',
    rowGap: 20,
  },
  partnerRegisterFormFiield: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    fontSize: '12px',
    fontWeight: '600',
  },
  partnerRegisterHeading: {
    fontSize: '14px',
    fontWeight: '600',
    color: radiologyColor?.deepBlue,
    textDecoration: 'underline',
    textAlign: 'center',
    marginLeft: '27%',
  },
  partnerRegisterFormActions: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'end',
    width: '76%',
  },
  partnerRegisterFormColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: 20,
    marginBottom: 30,
  },
  partnerFormWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
    padding: '1rem',
  },
  labelContainer: {
    textAlign: 'right',
    minWidth: '200px',
    marginTop: '10px',
  },
  submitAction: {
    width: '35% !important',
  },
  locationInput: {
    width: '300px !important',
    '& .MuiAutocomplete-input': {
      fontSize: '12px',
    },
    '& .MuiAutocomplete-listbox .MuiAutocomplete-option': {
      fontSize: '12px',
    },
    '& .MuiAutocomplete-root': {
      width: '300px !important',
    },
    '& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment': {
      right: '25px',
      display: 'flex',
      '& .MuiAutocomplete-clearIndicator': {
        padding: 'unset !important',
      },
      '& .MuiAutocomplete-popupIndicator': {
        padding: 'unset !important',
      },
    },
  },
})
const StyledPaper = styled(Paper)(() => ({
  '& .MuiAutocomplete-listbox': {
    fontSize: '12px',
  },
}))

const StyledList = styled(List)(() => ({
  '& .MuiAutocomplete-option': {
    fontSize: '12px',
  },
}))
const PartnerForm = ({ partner }: { partner?: any }) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const autocompleteRef = useRef<HTMLDivElement | null>(null)
  const classes = useCustomStyles(styles, theme)
  const [apiLoading, setApiLoading] = useState(false)
  const locations = useAppSelector(selectLocations)
  const filteredLocations = locations
    ?.filter((e: any) => e?.resource?.status === forms?.active?.toLowerCase())
    ?.map((e: any) => e?.resource?.name)
  const [openList, setOpenList] = useState(false)

  const handleOpen = () => {
    setOpenList(true)
  }

  const handleListClose = () => {
    setOpenList(false)
  }
  const initialFormState = {
    type: 'b2bPartner',
    name: '',
    phoneNumber: '',
    email: '',
    govId: '',
    department: '',
    designation: '',
    isLab: false,
    isRadiology: false,
    isVendorRelate: false,
    isCustomerRelate: false,
    odoo_partner_id: '',
    location: '',
    status: 'active',
    fhirId: '',
    address: '',
    pricelist: '',
    street_no: '',
    street: '',
    city: '',
    state: '',
    pin: '',
    gst: '',
    pan: '',
  }

  const [partnerData, setPartnerData] = useState<PartnerProps>(() => {
    if (partner) {
      return {
        ...partner,
        pricelist:
          partner?.price_list && partner?.price_list.length > 0
            ? partner?.price_list?.[0]?.id?.toString() ?? ''
            : '',
      }
    }
    return initialFormState
  })
  const [selectedpriceList, setSelectedPriceList] = useState<PriceListItem[]>(
    []
  )

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    submitForm,
    setFieldValue,
  } = useFormik<PartnerProps>({
    initialValues: {
      ...partnerData,
      pricelist: partner?.price_list ?? '',
    },
    validationSchema: Yup.object({
      name: Yup.string()?.required(fieldRequriedError),
      phoneNumber: Yup.string()
        ?.matches(phoneRegExp, phoneFieldError)
        ?.required(fieldRequriedError),
      email: Yup.string()?.email(emailFieldError),
      pricelist: Yup.string()?.required(reqPriceList),
    }),
    onSubmit: (values) => {
      handleRegistrationSubmit(values)
    },
    enableReinitialize: true,
  })
  const handleRegistrationSubmit = async (data: Record<string, any>) => {
    setApiLoading(true)
    const {
      name,
      phoneNumber,
      email,
      fhirId,
      id,
      isLab,
      isRadiology,
      isVendorRelate,
      isCustomerRelate,
      status,
    } = data
    const matchedPriceList = selectedpriceList?.find(
      (item: any) => item?.id?.toString() === values?.pricelist?.toString()
    )
    setPartnerData((prev) => ({
      ...prev,
      price_list: matchedPriceList
        ? [{ id: matchedPriceList.id, name: matchedPriceList.name }]
        : [],
    }))
    const formatted = {
      type: intent?.b2bPartner,
      name,
      id,
      mobile_number: phoneNumber,
      email,
      fhir_id: fhirId,
      created_by: !id ? KeycloakService.getUsername() : undefined,
      updated_by: KeycloakService.getUsername(),
      status: id ? status : formValues?.active,
      ...(id && {
        odoo_partnerId: values?.odoo_partner_id,
        date_changed: new Date().toISOString(),
      }),
      isLab: !!isLab,
      isRadiology: !!isRadiology,
      isCustomerRelate: !!isCustomerRelate,
      isVendorRelate: !!isVendorRelate,
      location: values?.location || '',
      price_list: values?.pricelist,
      street_no: values?.street_no || '',
      street: values?.street || '',
      city: values?.city || '',
      state: values?.state || '',
      pin: values?.pin || '',
      gst: values?.gst || '',
      pan: values?.pan || '',
    }
    const stateBody = { organization: formatted }
    const operation = id
      ? OrganizationIntent?.editOrganization
      : OrganizationIntent?.createOrganization
    try {
      const response = await startSxpProxy(
        ADMIN_PROJECT_ID,
        operation,
        stateBody
      )
      toast.success(response?.data?.message)
      navigate(radiologyEndPoint.referredOut)
    } catch (error: any) {
      toast.error(error?.data?.message)
    } finally {
      setApiLoading(false)
    }
  }
  const getAllPriceListData = async () => {
    try {
      const res = await getAllPriceList()
      const list: PriceListItem[] = res?.map((item: any) => ({
        id: item?.id,
        name: item?.name,
      }))
      setSelectedPriceList(list)
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getAllPriceListData()
  }, [])

  return (
    <>
      <div className={classes?.partnerRegisterFormContainer}>
        <form>
          <div className={classes?.partnerFormWrapper}>
            <div className={classes?.partnerRegisterHeading}>{partnerForm}</div>

            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='name' className={classes?.labelContainer}>
                Name
                <Asterisk />
              </label>
              <TextField
                fullWidth
                size='small'
                id='name'
                name='name'
                value={values?.name ?? ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.name && Boolean(errors?.name)}
                helperText={touched?.name && errors?.name}
              />
            </div>

            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='Phone Number' className={classes?.labelContainer}>
                Phone Number :<Asterisk />
              </label>
              <TextField
                fullWidth
                size='small'
                id='Phone Number'
                name='phoneNumber'
                value={values?.phoneNumber ?? ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.phoneNumber && Boolean(errors?.phoneNumber)}
                helperText={touched?.phoneNumber && errors?.phoneNumber}
              />
            </div>

            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='email' className={classes?.labelContainer}>
                Email Id :
              </label>
              <TextField
                fullWidth
                size='small'
                name='email'
                id='email'
                value={values?.email ?? ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.email && Boolean(errors?.email)}
                helperText={touched?.email && errors?.email}
              />
            </div>

            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='department' className={classes?.labelContainer}>
                Department :
              </label>
              <TextField
                fullWidth
                size='small'
                name='department'
                id='department'
                value={values?.department ?? ''}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>

            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='designation' className={classes?.labelContainer}>
                Designation :
              </label>
              <TextField
                fullWidth
                size='small'
                name='designation'
                id='designation'
                value={values?.designation}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>

            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='location' className={classes?.labelContainer}>
                Location :
              </label>

              <Autocomplete
                ref={autocompleteRef}
                options={filteredLocations}
                open={openList}
                value={values?.location || null}
                onOpen={handleOpen}
                onClose={handleListClose}
                isOptionEqualToValue={(option, value) => option === value}
                getOptionLabel={(option) => option || ''}
                onChange={(_, value) => {
                  setFieldValue('location', value)
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size='small'
                    placeholder='Select Location'
                    name='location'
                    onBlur={handleBlur}
                    error={touched?.location && Boolean(errors?.location)}
                    helperText={touched?.location && errors?.location}
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props} key={option}>
                    {option}
                  </li>
                )}
                PaperComponent={(props) => <StyledPaper {...props} />}
                ListboxComponent={(props) => <StyledList {...props} />}
                className={classes?.locationInput}
              />
            </div>
            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='location' className={classes?.labelContainer}>
                Price List :
                <Asterisk />
              </label>
              <TextField
                select
                fullWidth
                size='small'
                name='pricelist'
                id='priceList'
                value={values?.pricelist}
                onChange={handleChange}
                onBlur={handleBlur}
              >
                {selectedpriceList?.map((option) => (
                  <MenuItem key={option?.id} value={option?.id?.toString()}>
                    {option?.name}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            {partner?.id && (
              <div className={classes?.partnerRegisterFormFiield}>
                <label className={classes?.labelContainer}>Status :</label>
                <TextField
                  fullWidth
                  size='small'
                  select
                  name='status'
                  value={values?.status ?? ''}
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {activeOptions.map((option) => (
                    <MenuItem key={option?.value} value={option?.value}>
                      {option?.label}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            )}

            <div className={classes?.partnerRegisterFormFiield}>
              <label className={classes?.labelContainer}>Service :</label>
              <div className='partner-container'>
                <FormControlLabel
                  labelPlacement='end'
                  label='Lab'
                  control={
                    <Checkbox
                      size='small'
                      checked={values.isLab}
                      onChange={handleChange}
                      name='isLab'
                    />
                  }
                />
                <FormControlLabel
                  labelPlacement='end'
                  label='Radiology'
                  control={
                    <Checkbox
                      size='small'
                      checked={values.isRadiology}
                      onChange={handleChange}
                      name='isRadiology'
                    />
                  }
                />
              </div>
            </div>

            <div className={classes?.partnerRegisterFormFiield}>
              <label className={classes?.labelContainer}>Partner Type :</label>
              <div className='partner-container'>
                <FormControlLabel
                  labelPlacement='end'
                  label='isVendor'
                  control={
                    <Checkbox
                      size='small'
                      checked={values?.isVendorRelate}
                      onChange={handleChange}
                      name='isVendorRelate'
                    />
                  }
                />
                <FormControlLabel
                  labelPlacement='end'
                  label='isCustomer'
                  control={
                    <Checkbox
                      size='small'
                      checked={values?.isCustomerRelate}
                      onChange={handleChange}
                      name='isCustomerRelate'
                    />
                  }
                />
              </div>
            </div>
            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='streetNo' className={classes?.labelContainer}>
                Street No :
              </label>
              <TextField
                fullWidth
                size='small'
                name='street_no'
                id='streetNo'
                value={values?.street_no ?? ''}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>

            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='street' className={classes?.labelContainer}>
                Street :
              </label>
              <TextField
                fullWidth
                size='small'
                name='street'
                id='street'
                value={values?.street ?? ''}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>

            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='city' className={classes?.labelContainer}>
                City :
              </label>
              <TextField
                fullWidth
                size='small'
                name='city'
                id='city'
                value={values?.city ?? ''}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>

            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='state' className={classes?.labelContainer}>
                State :
              </label>
              <TextField
                fullWidth
                size='small'
                name='state'
                id='state'
                value={values?.state ?? ''}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>

            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='pin' className={classes?.labelContainer}>
                PIN :
              </label>
              <TextField
                fullWidth
                size='small'
                name='pin'
                id='pin'
                value={values?.pin ?? ''}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>

            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='gst' className={classes?.labelContainer}>
                GST No :
              </label>
              <TextField
                fullWidth
                size='small'
                name='gst'
                id='gst'
                value={values?.gst ?? ''}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>

            <div className={classes?.partnerRegisterFormFiield}>
              <label htmlFor='pan' className={classes?.labelContainer}>
                PAN No :
              </label>
              <TextField
                fullWidth
                size='small'
                name='pan'
                id='pan'
                value={values?.pan ?? ''}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>

            <div className={classes?.partnerRegisterFormActions}>
              <Button
                variant='contained'
                color='primary'
                size='small'
                type='submit'
                onClick={submitForm}
                disabled={apiLoading}
                className={classes?.submitAction}
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
export default PartnerForm
